import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';

const fmt = (n) => `$${n.toLocaleString()}`;

const PricingTiers = ({ service, onQuote }) => (
  <div className="grid sm:grid-cols-3 gap-4" data-testid={`pricing-tiers-${service.slug}`}>
    {service.tiers.map((t, i) => {
      const featured = i === 1;
      return (
        <div
          key={t.name}
          data-testid={`tier-${service.slug}-${t.name.toLowerCase()}`}
          className={`relative rounded-xl p-5 border transition-transform duration-300 hover:-translate-y-1 ${
            featured ? 'bg-gray-900 text-white border-gray-900 shadow-xl' : 'bg-white text-gray-900 border-gray-200'
          }`}
        >
          {featured && (
            <span className="absolute -top-3 left-5 text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full text-white" style={{ backgroundColor: '#D97904' }}>
              Most Popular
            </span>
          )}
          <p className="text-sm font-semibold uppercase tracking-wide opacity-80">{t.name}</p>
          <p className={`text-sm line-through mt-2 ${featured ? 'text-gray-300' : 'text-gray-500'}`}>
            Market avg {fmt(t.market)}
          </p>
          <p className="text-3xl font-bold mt-1" style={{ color: featured ? '#FF9900' : '#D97904' }}>
            {fmt(t.price)}
          </p>
          <p className={`text-xs mt-1 ${featured ? 'text-gray-300' : 'text-gray-500'}`}>{service.billing}</p>
          <ul className="mt-4 space-y-2">
            {t.features.map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm">
                <Check className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#D97904' }} />
                <span className={featured ? 'text-gray-200' : 'text-gray-700'}>{f}</span>
              </li>
            ))}
          </ul>
          <Button
            data-testid={`quote-btn-${service.slug}-${t.name.toLowerCase()}`}
            onClick={() => onQuote(`${service.title} - ${t.name}`)}
            className="w-full mt-5 text-white hover:opacity-90"
            style={{ backgroundColor: '#D97904' }}
          >
            Get a Quote
          </Button>
        </div>
      );
    })}
  </div>
);

export default PricingTiers;
